import Heading from "../Components/Heading/Heading";
import LiContent from "../Components/LiContent/LiContent";
import Line from "../Components/Line/Line";
import RelatedT from "../Components/RelatedArticles/Related";
import ConvertButton from "../Components/ConvertButton";
import React from "react";
import FAQComponent from "../Components/FAQComponent/FAQComponent";

function TheLounge(){
    const related = [
        {
            href: '/facebook',
            name: 'Facebook',
            side: 'partial support',
            text: 'Facebook is by far the most-known social network. Learn how to use JXL images within Facebook.'
        },
        {
            href: '/the-lounge',
            name: 'The Lounge',
            side: 'no support',
            text: 'The Lounge is a modern web-based IRC client. Learn how to use JXL images within The Lounge.'
        }
    ]
    return(
        <>
            <Heading h='The Lounge JPEG XL support' p='#tutorials'/>
            <article>
                <nav className='content_table'>
                    <h4>Table of Content</h4>
                    <ol className='content_ol'>
                        <LiContent n='1' a='#what-is-the-lounge' text='What is The Lounge?'/>
                        <LiContent n='2' a='#the-lounge-jxl-support' text='The Lounge JXL support'/>
                    </ol>
                </nav>
                <br/>
                <Line/>

                <span id='what-is-the-lounge'>
                    <h1 className="main">What is The Lounge?</h1>
                    <p className='umain'>Developed for self-hosting, The Lounge is a modern web interface for IRC. A variety of new features bring IRC into the 21st century, including push notifications, link previews, and message markers. The Node.js server runs on any OS, so it does not matter what operating system you use. It is compatible with desktop, smartphone, and tablet computers. You can continue where you left off regardless of the device you are using. Open source and licensed under the MIT license, the Lounge can be accessed by anyone worldwide.</p>
                </span>
                <Line/>

                <span id='the-lounge-jxl-support'>
                    <h1 className="main">The Lounge JXL support</h1>
                    <p className='umain'>As of now (26.10.21), preview images are displayed for WebP and AVIF, but not JPEG XL. JPEG XL Preview support is being shipped in the upcoming 4.3.0 milestone at an unknown date.</p>
                </span>
                <Line/>
                <br/><FAQComponent/><br/>

                <RelatedT related={related}/>
            </article>


            <ConvertButton/>
            <br/>
        </>
    )
}

export default TheLounge